import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, Button, DataTable, DialogSubscription, SubscriptionsList, SubscriptionsData, makeStyles, Typography, SingleBarChart } from "../../../../../";
import moment from "moment";
import _ from "lodash";
import { ButtonGroup } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    table: {
      display: "flex",
      "align-items": "top",
      "justify-content": "space-around"
    }
  };
});

var Subscriptions = function Subscriptions(props) {
  console.log("Subscriptions props", props);
  var data = props.data,
      columns = props.columns,
      title = props.title,
      options = props.options,
      createSubscription = props.createSubscription,
      editSubscription = props.editSubscription,
      language = props.language,
      dashboard = props.dashboard,
      plans = props.plans,
      products = props.products,
      clients = props.clients,
      translation = props.translation,
      year = props.year,
      handleChangeYear = props.handleChangeYear;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAdd = _useState2[0],
      setOpenAdd = _useState2[1];

  var classes = useStyles();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openEdit = _useState4[0],
      setEditOpen = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      subscriptions = _useState8[0],
      setSubcriptions = _useState8[1];

  var _useState9 = useState("all"),
      _useState10 = _slicedToArray(_useState9, 2),
      country = _useState10[0],
      setCountry = _useState10[1]; // console.log('data', data)


  useEffect(function () {
    setSubcriptions(data && _toConsumableArray(data)
    /* .filter(subscription => subscription.country === "ES") */
    ); // console.log('first useeffect', subscriptions)
  }, [data]);
  useEffect(function () {
    country === "all" ? setSubcriptions(_toConsumableArray(data)) : setSubcriptions(_toConsumableArray(data).filter(function (subscription) {
      return subscription.country === country;
    })); // console.log('country use effect', franchises)
  }, [country]);

  var handleDialogAdd = function handleDialogAdd() {
    setOpenAdd(!openAdd);
  };

  var filterData = function filterData(country) {
    return setCountry(country);
  };

  var handleDialogEdit = function handleDialogEdit(id) {
    if (!openEdit) {
      var franchise = data.find(function (franchise) {
        return franchise._id === id;
      });
      setSelected(franchise);
    } else {
      setSelected({});
    }

    setEditOpen(!openEdit);
  };

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      forecast = _useState12[0],
      setForecast = _useState12[1];

  var createForecast = function createForecast(lastMonth) {
    var forecast = [];

    var _loop = function _loop(i) {
      subscriptions && subscriptions.forEach(function (sub) {
        // console.group("subscription", sub.name);
        // console.log("amount", sub.subscription.amount);
        // console.log("stripe", sub.subscription.stripe);
        // console.groupEnd();
        sub.subscription.stripe && forecast.push({
          type: "forecast",
          date: moment(i, "M").format(),
          subtotal: sub.subscription.amount // ? sub.subscription.amount
          // : sub.subscription.fixed

        });
      });
    };

    for (var i = +lastMonth + 1; i <= 12; i++) {
      _loop(i);
    }

    return forecast;
  };

  useEffect(function () {
    dashboard && dashboard[country] && dashboard[country].sub_invoices && setForecast(createForecast(dashboard[country].sub_invoices[0] && moment(dashboard[country].sub_invoices.sort(function (a, b) {
      if (a.date < b.date) {
        return 1;
      } else if (a.date > b.date) {
        return -1;
      } else return 0;
    })[0].date).format("M")));
  }, [subscriptions, country]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogSubscription, {
    open: openAdd,
    plans: plans,
    products: products,
    clients: clients,
    onClose: handleDialogAdd,
    variant: "add",
    createSubscription: createSubscription
  }), /*#__PURE__*/React.createElement(DialogSubscription, {
    open: openEdit,
    plans: plans,
    products: products,
    clients: clients,
    onClose: handleDialogEdit,
    variant: "edit",
    editSubscription: editSubscription,
    data: selected
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Subscriptions"), /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    "aria-label": "outlined primary button group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: year === "2020" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2020");
    }
  }, "2020"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2021" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2021");
    }
  }, "2021"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2022" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2022");
    }
  }, "2022"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2023" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2023");
    }
  }, "2023")), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: handleDialogAdd
  }, "+ Add Subscription")), /*#__PURE__*/React.createElement(SubscriptionsData, {
    dashboard: dashboard,
    country: country,
    forecast: forecast
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.table
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(SubscriptionsList, {
    subscriptions: data,
    filterData: filterData
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_subscriptions",
    columns: columns,
    title: title,
    options: options,
    data: subscriptions
  }))));
};

export default Subscriptions;